import {
  APOLLO_CLIENTS,
  CustomContext,
  initializeApollo,
} from '@/graphql/client';
import type {
  OrderAppProductVariantsBusinessDetailsQuery,
  OrderAppProductVariantsBusinessDetailsQueryVariables,
} from '@/graphql/orderApp/api';
import { ProductVariantsBusinessDetailsDocument } from '@/graphql/orderApp/api';
import { allowedCountries } from '@/lib/eccomerceCountries';
import { isAbortLikeError } from '@/lib/errors';
import { getCountryCodeByChannel } from '@/lib/regions';

export const fetchProductBusinessData = async (
  skus: string[],
  channel: string,
) => {
  const countryCode = getCountryCodeByChannel(channel);
  if (!allowedCountries?.includes(countryCode ?? 'zz'))
    return {
      productVariants: [],
    } as OrderAppProductVariantsBusinessDetailsQuery;

  const client = initializeApollo();
  try {
    const { data: orderAppData } = await client.query<
      OrderAppProductVariantsBusinessDetailsQuery,
      OrderAppProductVariantsBusinessDetailsQueryVariables
    >({
      query: ProductVariantsBusinessDetailsDocument,
      variables: { skus: skus, channel: channel },
      context: CustomContext({
        disableErrorNotification: true,
        client: APOLLO_CLIENTS.orderApp,
      }),
      //TODO  default fetchPolicy is cache-first, cta data should not use cache data, but if use network-only ,useQuery will call every render, need add cache logic
    });
    return (
      orderAppData ??
      ({ productVariants: [] } as OrderAppProductVariantsBusinessDetailsQuery)
    );
  } catch (err) {
    if (isAbortLikeError(err)) {
      return {
        productVariants: [],
      } as OrderAppProductVariantsBusinessDetailsQuery;
    }
    console.warn(
      '[fetchProductBusinessData] fetchProductBusinessData failed:',
      err,
    );
  }
};
